import React from "react";

const COMPONENT_CLASS = "c-summary-tile";

export type SummaryTileTone = "muted" | "white";
export type SummaryTilePadding = "default" | "compact";

export interface SummaryTileProps {
    tone?: SummaryTileTone;
    /** "default" = 2rem, "compact" = 1rem. */
    padding?: SummaryTilePadding;
    className?: string;
    children?: React.ReactNode;
}

/**
 * Card shell used to group summary/stat content (billing status cards,
 * organization list tiles, ...). Provides the shared card chrome only;
 * consumers own their inner layout, typography and spacing via their own BEM
 * classes (same composition pattern as Modal).
 */
const SummaryTile: React.FC<SummaryTileProps> = (props) => {
    const {
        tone = "muted",
        padding = "default",
        className,
        children,
    } = props;

    return (
        <div className={`${COMPONENT_CLASS} ${tone === "white" ? "-white" : ""} ${padding === "compact" ? "-compact" : ""} ${className ?? ""}`}>
            {children}
        </div>
    );
};

export { SummaryTile };
export default SummaryTile;
